/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CommunityDto } from '../../models/community-dto';

export interface CommunityControllerMyV1$Params {
}

export function communityControllerMyV1(http: HttpClient, rootUrl: string, params?: CommunityControllerMyV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CommunityDto>>> {
  const rb = new RequestBuilder(rootUrl, communityControllerMyV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CommunityDto>>;
    })
  );
}

communityControllerMyV1.PATH = '/api/v1/community/my';
